<payee-popup title="Dokumentumok generálása">
  <mat-progress-spinner
    *ngIf="loading; else errorMessagesTemplate"
    mode="indeterminate"
    diameter="48"
  ></mat-progress-spinner>
  <ng-template #errorMessagesTemplate>
    <ng-container *ngIf="(errorMessages | keyvalue).length > 0">
      <h1>Validációs hibák</h1>
      <ul>
        <li *ngFor="let error of errorMessages | keyvalue">
          <span class="error-key">{{ error.key }}</span>
          <ul>
            <li *ngFor="let message of error.value">{{ message }}</li>
          </ul>
        </li>
      </ul>
    </ng-container>
  </ng-template>
  <ng-template #payeePopupSubmitTemplate>
    <button payee-button color="alert-green" width="wide" (click)="submit()">
      Generálás
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button payee-button color="alert-red" width="wide" mat-dialog-close>
      Mégse
    </button>
  </ng-template>
</payee-popup>
